export const zIndex = {
  calendarPopup: 11,
  menuList: 4,
  footer: 3,
  menuListActive: 2,
};

export const NavKey = {
  left: 'ArrowLeft',
  up: 'ArrowUp',
  right: 'ArrowRight',
  down: 'ArrowDown',
  pageUp: 'PageUp',
  pageDown: 'PageDown',
  enter: 'Enter',
};
